module.exports = "/_next/static/images/12b03565e5bcbdebb4e39cf9fe6c7538-mgm-lg-2x-v2.jpg.webp";